"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportForm = void 0;
var CustomSelect_1 = __importDefault(require("@common/components/CustomSelect"));
var Button_1 = __importStar(require("@components/Button"));
var SelectDropdown_1 = __importDefault(require("@components/SelectDropdown"));
var statDateUtil_1 = require("@features/StatisticPage/components/DatePicker/statDateUtil");
var overviewSlice_1 = require("@features/StatisticPage/state/overviewSlice");
var _store_1 = require("@store");
var date_1 = require("@utils/date/date");
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var MS_IN_62_DAYS = 1000 * 60 * 60 * 24 * 62;
var MS_IN_48_HOURS = 1000 * 60 * 60 * 48;
var contentTypeColumnMinDate = new Date(2023, 2, 23);
var groupByQueueMinDate = new Date(2023, 2, 7);
function ReportForm(_a) {
    var domain = _a.domain, currentUserEmail = _a.currentUserEmail, closeModal = _a.closeModal, teamName = _a.teamName;
    var dispatch = (0, _store_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var urlParams = new URLSearchParams(window.location.search);
    var _b = __read((0, statDateUtil_1.getDefaultValuesFromUrlParams)(urlParams), 2), urlFromValue = _b[0], urlToValue = _b[1];
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var aggregationInterval = (0, react_redux_1.useSelector)(overviewSlice_1.aggregationIntervalOverviewSelector);
    var toValue = (0, date_fns_1.min)([urlToValue, new Date()]);
    var rangeInMs = toValue.getTime() - urlFromValue.getTime();
    var granularityOptions = [
        { id: 'none', text: t('statistics:REPORT_MODAL.GRANULARITY.NONE') },
        { id: 'year', text: t('statistics:REPORT_MODAL.GRANULARITY.YEAR') },
        { id: 'month', text: t('statistics:REPORT_MODAL.GRANULARITY.MONTH') },
        {
            id: 'day',
            text: t('statistics:REPORT_MODAL.GRANULARITY.DAY'),
            isDisabled: rangeInMs > MS_IN_62_DAYS,
        },
        {
            id: 'hour',
            text: t('statistics:REPORT_MODAL.GRANULARITY.HOUR'),
            isDisabled: rangeInMs > MS_IN_48_HOURS,
        },
    ];
    var isGroupByQueueDisabled = (0, date_fns_1.isBefore)(urlFromValue, groupByQueueMinDate) || (0, date_fns_1.isBefore)(toValue, groupByQueueMinDate);
    var groupByOptions = [
        { id: 'none', text: t('statistics:REPORT_MODAL.GROUP.NONE') },
        { id: 'agent', text: t('statistics:REPORT_MODAL.GROUP.AGENT') },
        { id: 'category', text: t('statistics:REPORT_MODAL.GROUP.CATEGORY') },
        { id: 'queue', text: t('statistics:REPORT_MODAL.GROUP.QUEUE'), isDisabled: isGroupByQueueDisabled },
        { id: 'rule', text: t('statistics:REPORT_MODAL.GROUP.RULE_MATCHED') },
        { id: 'type', text: t('statistics:REPORT_MODAL.GROUP.TYPE') },
    ];
    var _c = (0, react_hook_form_1.useForm)({
        defaultValues: {
            aggregationGranularity: aggregationInterval,
            groupBy: 'none',
            columnsToInclude: [],
        },
    }), handleSubmit = _c.handleSubmit, control = _c.control, errors = _c.formState.errors;
    var isContentTypeColumnDisabled = (0, date_fns_1.isBefore)(urlFromValue, contentTypeColumnMinDate) || (0, date_fns_1.isBefore)(toValue, contentTypeColumnMinDate);
    var columnsOptions = [
        {
            id: 'includeDecisionType',
            text: t('statistics:REPORT_MODAL.COLUMNS.DECISION_TYPE'),
            order: 1,
        },
        {
            id: 'includeContentType',
            text: t('statistics:REPORT_MODAL.COLUMNS.CONTENT_TYPE'),
            order: 2,
            isDisabled: isContentTypeColumnDisabled,
        },
        { id: 'includeModerationTime', text: t('statistics:REPORT_MODAL.COLUMNS.TIME_TO_MODERATION'), order: 3 },
        { id: 'includeModerationDecisionDetails', text: t('statistics:REPORT_MODAL.COLUMNS.MODERATION_OUTCOME'), order: 4 },
        { id: 'includeRefusalReasons', text: t('statistics:REPORT_MODAL.COLUMNS.REFUSAL_REASON'), order: 5 },
        { id: 'includeFeedbackReasons', text: t('statistics:REPORT_MODAL.COLUMNS.FEEDBACK_REASON'), order: 6 },
    ];
    // add attribute  columnsToInclude?: Array<ReportColumnOption>; to ReportFormDataApi
    // data type is ReportFormDataApi with columnsToInclude
    var onSubmit = function (data) {
        var _a;
        closeModal();
        var includedColumnsIds = (_a = data.columnsToInclude) === null || _a === void 0 ? void 0 : _a.map(function (column) { return column.id; });
        var includeDecisionType = (includedColumnsIds === null || includedColumnsIds === void 0 ? void 0 : includedColumnsIds.includes('includeDecisionType')) || false;
        var includeContentType = (includedColumnsIds === null || includedColumnsIds === void 0 ? void 0 : includedColumnsIds.includes('includeContentType')) || false;
        var includeModerationTime = (includedColumnsIds === null || includedColumnsIds === void 0 ? void 0 : includedColumnsIds.includes('includeModerationTime')) || false;
        var includeModerationDecisionDetails = (includedColumnsIds === null || includedColumnsIds === void 0 ? void 0 : includedColumnsIds.includes('includeModerationDecisionDetails')) || false;
        var includeRefusalReasons = (includedColumnsIds === null || includedColumnsIds === void 0 ? void 0 : includedColumnsIds.includes('includeRefusalReasons')) || false;
        var includeFeedbackReasons = (includedColumnsIds === null || includedColumnsIds === void 0 ? void 0 : includedColumnsIds.includes('includeFeedbackReasons')) || false;
        var apiData = {
            aggregationGranularity: data.aggregationGranularity,
            groupBy: data.groupBy,
            teamName: teamName,
            timeZone: timezone,
            startDate: (0, date_1.formatISO)(urlFromValue),
            endDate: (0, date_1.formatISO)(toValue),
            creatorEmail: currentUserEmail,
            sendTo: [currentUserEmail],
            includeDecisionType: includeDecisionType,
            includeContentType: includeContentType,
            includeModerationTime: includeModerationTime,
            includeModerationDecisionDetails: includeModerationDecisionDetails,
            includeRefusalReasons: includeRefusalReasons,
            includeFeedbackReasons: includeFeedbackReasons,
        };
        dispatch((0, overviewSlice_1.requestForReport)(domain, apiData));
    };
    return (react_1.default.createElement("form", { className: "report-modal" },
        react_1.default.createElement("div", { className: "header" },
            react_1.default.createElement("h3", null, t('statistics:REPORT_MODAL.TITLE'))),
        react_1.default.createElement("div", { className: "form-part" },
            react_1.default.createElement("p", null, t('statistics:REPORT_MODAL.SELECTED_TIME_PERIOD')),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { className: "time-period" },
                    react_1.default.createElement("b", null, t('statistics:REPORT_MODAL.START_DATE'))),
                ' ',
                (0, date_1.formatDate)(urlFromValue),
                " (",
                timezone,
                ")"),
            react_1.default.createElement("p", null,
                react_1.default.createElement("span", { className: "time-period" },
                    react_1.default.createElement("b", null, t('statistics:REPORT_MODAL.END_DATE'))),
                ' ',
                (0, date_1.formatDate)(toValue),
                " (",
                timezone,
                ")")),
        react_1.default.createElement("div", { className: "form-part" },
            react_1.default.createElement("p", null, t('statistics:REPORT_MODAL.BREAK_DOWN_MODERATED_ITEM_COUNTS_BY')),
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: "aggregationGranularity", rules: { required: true }, render: function (_a) {
                    var field = _a.field;
                    return (react_1.default.createElement(SelectDropdown_1.default, { hasError: errors.aggregationGranularity !== undefined, items: granularityOptions, selectedItemId: "".concat(field.value), onItemSelected: function (id) { return field.onChange(id); } }));
                } })),
        react_1.default.createElement("div", { className: "form-part" },
            react_1.default.createElement("p", null, t('statistics:REPORT_MODAL.GROUP_MODERATED_ITEM_COUNTS_BY')),
            react_1.default.createElement(react_hook_form_1.Controller, { name: "groupBy", control: control, rules: { required: true }, render: function (_a) {
                    var field = _a.field;
                    return (react_1.default.createElement(SelectDropdown_1.default, { hasError: errors.groupBy !== undefined, items: groupByOptions, selectedItemId: "".concat(field.value), onItemSelected: function (id) { return field.onChange(id); } }));
                } })),
        react_1.default.createElement("div", { className: "form-part" },
            react_1.default.createElement("p", null, t('statistics:REPORT_MODAL.INCLUDE_COLUMNS_FOR')),
            react_1.default.createElement(react_hook_form_1.Controller, { name: "columnsToInclude", control: control, render: function (_a) {
                    var field = _a.field;
                    return (react_1.default.createElement(CustomSelect_1.default, { isMulti: true, getOptionLabel: function (option) { return option.text; }, getOptionValue: function (option) { return option.id; }, options: columnsOptions, onChange: field.onChange, 
                        // The reason for this is that the order of the columns in the report CSV is fixed and matches the order in which the option are listed in the drop-down
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        value: field.value.sort(function (a, b) { return a.order - b.order; }) }));
                } })),
        react_1.default.createElement("div", { className: "form-part" },
            react_1.default.createElement("p", null, t('statistics:REPORT_MODAL.SEND_CSV_REPORT_TO')),
            react_1.default.createElement("input", { type: "text", disabled: true, value: currentUserEmail, className: "form-control sendTo" })),
        react_1.default.createElement("div", { className: "form-part bottom" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Button_1.SecondaryButton, { text: t('statistics:REPORT_MODAL.CANCEL'), onClick: closeModal }),
                react_1.default.createElement(Button_1.default, { text: t('statistics:REPORT_MODAL.EXPORT'), onClick: handleSubmit(onSubmit) })))));
}
exports.ReportForm = ReportForm;
